import React, { ReactElement } from 'react';
import { InfoCircleOutlined } from '@severalnines/frontend_hub/libs/icons';

function CcxIconInfoCircleOutlined(): ReactElement {
    return <InfoCircleOutlined />;
}

export default CcxIconInfoCircleOutlined;
